
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M22.439 3.9l-3.317 3.316h-2.338V4.878L20.1 1.561a5.752 5.752 0 00-8.168 7L1.589 18.9A2.48 2.48 0 005.1 22.411l10.34-10.344a5.752 5.752 0 007-8.168z"}})])
          )
        }
      }
    